module.exports = __webpack_public_path__ + "static/media/kneehyperextension_severe_left.e8350526.png";